import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';

export enum FeatureFlagsEnum {
  ACCOUNT_MAPPED_CSV_IMPORT = 'account-mapped-csv-import',
  ACCOUNTS_SEARCH = 'accounts-search',
  ACCOUNTS_SETUP_GUIDE = 'accounts-setup-guide',
  ADD_TEAMMATE_AND_INBOX_CTAS = 'add-teammate-and-inbox-ctas',
  AUTO_SHARE_DRAFTS = 'auto-share-drafts',
  BOOT_P3_PREFETCH = 'boot-p3-prefetch',
  BULLETED_LISTS_V2 = 'bulleted-lists-v-2',
  CANNED_ANSWERS_RESOURCE_CUSTOM_FIELDS = 'canned-answers-resource-custom-fields',
  CALENDAR_ATTACHMENTS = 'calendar-attachments',
  CHAT_PRESENCE_INDICATORS_ON_OFF_LINE = 'chat-presence-indicators-on-off-line',
  CIRCLES = 'circles',
  COMMENT_TOMBSTONE = 'comment-tombstone',
  COMPANY_CARDS = 'company-cards',
  COMPOSER_PARAGRAPH_SPACE_INDENTATION = 'composer-paragraph-space-indentation',
  COMPOSER_TABLE_SERVICE = 'composer-table-service',
  COMPOSER_REPLACE_PILLED_VARIABLES_IN_MESSAGE_TEMPLATES = 'composer-replace-pilled-variables-in-message-templates',
  CONTACTS_MANAGER_EXPORT_CONTACTS = 'contacts-manager-export-contacts',
  CONVERSATION_UPDATED_THIN_THROTTLING = 'conversation-updated-thin-throttling',
  CRM_SYNC_FULL_PAGE_SALESFORCE = 'crm-sync-full-page-salesforce',
  DATADOG_RUM = 'datadog-rum',
  DEFAULT_VIDEO_CONFERENCING = 'default-video-conferencing',
  FIND_MY_DRAFTS_2_LIST_COMMENT_DRAFTS_IN_DRAFTS_FOLDER = 'find-my-drafts-2-list-comment-drafts-in-drafts-folder',
  FRONT_CHAT_ADVANCED_EDITOR = 'front-chat-advanced-editor',
  GC_REMOVE_CYCLES = 'gc-remove-cycles',
  GIPHY_EMAIL_INTEGRATION = 'giphy-email-integration',
  GRAMMARY_INTEGRATION = 'grammarly-integration',
  GRAMMARLY_AUTOCOMPLETE = 'grammarly-autocomplete',
  GUEST_INVITE_NEW_COPY = 'guest-invite-new-copy',
  GUIDED_TRIAL_EXPERIENCE = 'guided-trial-experience',
  HACKATHON_GIFS = 'hackathon-gifs',
  HAS_REMOVED_ADDED_CALENDARS = 'has-remove-added-calendars',
  HELP_GUIDE = 'help-guide',
  HIDE_AUDIT_TRAIL = 'hide-audit-trail',
  INBOX_ZERO_ANIMATIONS = 'inbox-zero-animation-delighter',
  INSTANT_RESCHEDULE = 'ui-instant-reschedule-link',
  LAZY_TEAMMATES = 'lazy-teammates',
  LAZY_TEAMMATES_DROPDOWNS = 'lazy-teammates-dropdowns',
  LEGACY_CANNED_RESPONSE_SORTING = 'legacy-canned-response-sorting',
  LENSES = 'lenses',
  LIST_SENDING_MESSAGES_IN_SENT_FOLDER = 'list-sending-messages-in-sent-folder',
  LOCAL_APPLICATIONS = 'local-applications',
  LOG_DRAG_AND_DROP_OPERATIONS = 'log-drag-and-drop-operations',
  MICROSOFT_DYNAMICS_ACCOUNT_SYNC = 'microsoft-dynamics-account-sync',
  MOBILE_EDIT_CONTACT = 'mobile-edit-contact',
  MOBILE_EDIT_CONTACT_DESCRIPTION_LINKS = 'mobile-contact-details-editing-description-and-links',
  MOBILE_STORAGE_LOGGING = 'mobile-storage-logging',
  MORE_P2_PREFETCH = 'more-p2-prefetch',
  MOVE_TO_UNREACHABLE = 'move-to-unreachable',
  NATIVE_DELETE_EMAIL_COMPOSER = 'use-native-delete-in-email-composer',
  NEW_APPLICATIONS_ENTRY_POINTS = 'new-applications-entry-points',
  NEW_CONTACTS_MANAGER_ACCOUNTS = 'new-contact-manager-accounts',
  NEW_CONTACTS_MANAGER_V0 = 'new-contacts-manager-v0',
  NEW_INBOX_SETTINGS_DETAILS = 'new-inbox-settings-details',
  NEW_INTEGRATIONS_DISCOVERABILITY = 'new-integrations-discoverability',
  NEW_INTEGRATIONS_DISCOVERABILITY_P4 = 'new-integrations-discoverability-p4',
  NEW_P3_PREFETCH = 'new-p3-prefetch',
  NEW_PREFETCH_V3 = 'new-prefetch-v3',
  NEW_PUSHER_ON_RECONNECT = 'new-pusher-on-reconnect',
  NEW_TEAMMATE_INVITE = 'new-teammate-invite',
  NEW_VACATION_RESPONDERS = 'new-vacation-responders',
  NEW_VISITOR_URL_EXPERIENCE = 'new-visitor-url-experience',
  NEW_CHAT_SEEN_INDICATOR = 'new-chat-seen-indicator',
  NO_PENDO = 'no-pendo',
  NOTIFICATION_CENTER = 'notification-center',
  NOTIFY_CALENDAR_GUESTS = 'notify-calendar-guests',
  OFFLINE_CONVERSATION_CACHE = 'offline-conversation-cache',
  OLD_DESKTOP_VERSION_BANNER = 'old-desktop-version-banner',
  ONLINE_CLIENT_COUNTERS = 'online-client-counters',
  P1_ALPHABETIZATION = 'p-1-alphabetization',
  P1_AUTO_REC = 'p1-auto-recommendations',
  P2_CTAS = 'p2-ctas',
  P2_QUICK_ACTIONS = 'p2-quick-actions',
  P2_P3_DARK_MODE = 'p2-p3-dark-mode',
  P3_LINK_TRACKING = 'p3-link-tracking',
  P4_MULTI_VIEW = 'p4-multi-view',
  PERFORMANCE_DEBUG_LOGGING = 'performance-debug-logging',
  PERFORMANCE_METRIC_LOGGING_DESKTOP = 'performance-metric-logging',
  PERFORMANCE_METRIC_LOGGING_MOBILE = 'performance-metric-logging-mobile',
  PUSH_RECONNECT_ON_BACKLOG = 'push-reconnect-on-backlog',
  PUSH_REDUX_BATCHING = 'push-redux-batching',
  PUSH_RENDER_THROTTLING = 'push-render-throttling',
  PUSHER_ABLY_COMPARISON = 'pusher-ably-comparison',
  ABLY_FE_AUTHORITY = 'ably-fe-authority',
  QUOTE_COMMENT = 'quote-comment',
  RECENT_COMMUNICATIONS_BANNER = 'recent-communications-banner',
  RECENT_COMMUNICATIONS_COMPOSER_BANNER = 'recent-communications-composer-banner',
  RESOLVE_DRAFTS = 'resolve-drafts',
  RTL_LANGUAGE_SUPPORT = 'rtl-language-support',
  RULE_ACTION_SNOOZE_CONVERSATION = 'rule-action-snooze-conversation',
  RULE_CONDITION_DATE_IS = 'rule-condition-date-is',
  RULE_EDITOR_HIGHLIGHT_ERRORS = 'rule-editor-highlight-errors',
  RULE_FIX_UNREPLIED_AFTER_CONDITION = 'rule-fix-unreplied-after-condition',
  RULES_DRY_RUN = 'rules-dryrun',
  RULES_SHOULD_WRAP_TRIGGER_CONDITIONS = 'rules-should-wrap-trigger-conditions',
  SEARCH_ACCOUNT_FILTER = 'search-account-filter',
  SEARCH_HIGHLIGHT_ALGORITHMS = 'search-highlight-algorithms',
  SEARCH_USE_SEARCH_RAW_ENDPOINT = 'search-use-search-raw-endpoint',
  SERVICE_WORKER = 'service-worker',
  SETTINGS_AUTOLINKERS = 'settings-autolinkers',
  SETTINGS_HOMEPAGE = 'settings-homepage-client',
  SETTINGS_PREVIEWERS = 'settings-previewers',
  SHOW_15_MINUTE_EVENTS = 'show-15-minute-events',
  START_GUIDE_TEAMMATES = 'start-guide-teammates',
  SUPPORT_CHAT_FALLBACK = 'support-chat-fallback',
  SW_BOOT_CACHE_PATCHING = 'sw-boot-cache-patching',
  TABLE_BASED_RULES = 'table-based-rules',
  UPSELL_CARDS = 'upsell-cards',
  VISITOR_EXPERIENCE = 'guest-experience-ui-v2',
  VISITOR_EXPERIENCE_V3 = 'guest-experience-ui-v3',
  NEW_RECURRENCE_CLIENT = 'new-recurrence-client',
  BUSINESS_HOURS_INBOX = 'business-hours-inbox',
  INBOXES_FRONT_CLIENT = 'inboxes-front-client',
  DEVELOPER_SETTINGS = 'developer-settings',
  SENDGRID_DNS_SUBUSER = 'sendgrid-dns-subuser',
}

export const isFeatureFlagsEnum = makeEnumTypeGuard(FeatureFlagsEnum);
